import React, { useState } from 'react';
import ListRanches from './ListRanches.js';
import AddRanch from './AddRanch.js';
import { ListButton, AddButton, FAB } from '../../shared/ActionButtons';

export const Ranches = ({ screen, setScreen, hideHeader }) => {
  const [localScreen, setLocalScreen] = useState('list');

  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  return (
    <>
      {!hideHeader && (
        <div className="content-header">
          <div className="action-buttons">
            <ListButton
              isActive={currentScreen === 'list'}
              onClick={() => setCurrentScreen('list')}
            />
            <AddButton
              isActive={currentScreen === 'add'}
              onClick={() => setCurrentScreen('add')}
            />
          </div>
        </div>
      )}

      {currentScreen === 'list' && <ListRanches />}
      {currentScreen === 'list' && <FAB onClick={() => setCurrentScreen('add')} />}
      {currentScreen === 'add' && <AddRanch onSuccess={() => setCurrentScreen('list')} />}
    </>
  );
};

export const RanchesActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton
      isActive={screen === 'list'}
      onClick={() => setScreen('list')}
    />
    <AddButton
      isActive={screen === 'add'}
      onClick={() => setScreen('add')}
    />
  </div>
);

export default Ranches;
